/**
 * Preview · Chloe Bennett · interacciones
 * Mantener mínimo. Cero deps.
 */
(function () {
  'use strict';

  // ============ PAGE LOAD FADE ============
  // Se activa al instante con DOMContentLoaded (cuando body opacity 0 → 1)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.body.classList.add('is-loaded');
    });
  } else {
    document.body.classList.add('is-loaded');
  }


  // ============ SCROLL REVEAL ============
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.10, rootMargin: '0px 0px -6% 0px' }
    );

    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      observer.observe(el);
    });
  } else {
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      el.classList.add('in-view');
    });
  }


  // ============ MARQUEE LOOP (texto + fabric + top-bar) ============
  document.querySelectorAll('.marquee__track, .fabric__marquee-track, .top-bar__track').forEach(function (track) {
    track.innerHTML += track.innerHTML;
  });


  // ============ STICKY HEADER (solo en home, post-hero) ============
  var stickyHeader = document.getElementById('sticky-header');
  if (stickyHeader) {
    var lastScroll = 0;
    var trigger = 0;
    var ticking = false;

    function computeTrigger() {
      var hero = document.querySelector('.hero');
      trigger = hero ? hero.offsetHeight * 0.85 : window.innerHeight * 0.85;
    }
    computeTrigger();
    window.addEventListener('resize', computeTrigger, { passive: true });

    function onScroll() {
      var y = window.scrollY;
      if (y > trigger) {
        stickyHeader.classList.add('is-visible');
      } else {
        stickyHeader.classList.remove('is-visible');
      }
      // Hide on scroll down past start, show on scroll up (subtle dynamic behavior)
      if (y > trigger + 200) {
        if (y > lastScroll + 4) {
          stickyHeader.classList.add('is-hidden');
        } else if (y < lastScroll - 4) {
          stickyHeader.classList.remove('is-hidden');
        }
      } else {
        stickyHeader.classList.remove('is-hidden');
      }
      lastScroll = y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });
  }


  // ============ SMOOTH ANCHOR LINKS ============
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var href = a.getAttribute('href');
      if (href.length > 1) {
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });


})();
